import { component } from 'picoapp';
import Accordion from 'utils/accordion';

export default component((node) => {
  Accordion(node, {
    items: '[data-accordion]',
    trigger: '[data-accordion-trigger]',
    content: '[data-accordion-content]',
  });
});
